export default {"src":"/_next/static/media/wu.bb6460ed.svg","height":20,"width":20};